import { TFunction } from '@lyearn/i18n';
import { getContentCardStatus } from '@/modules/content/components/ContentCard/utils/getContentCardStatus';
import { getContentDuration } from '@/modules/content/components/ContentCard/utils/getContentDuration';
import { getKnowledgeAssetStaticCover } from '@/modules/corporate/components/LearningContent/Icon';
import { ResourceTypeEnum } from '@/types/schema';
import getHumanDuration from '@/utils/time/getHumanDurationRounded';

import { CardContentType } from '../types';
import {
  getContentCardDuration,
  getContentCardProgress,
  getContentDescription,
  getContentLabel,
  getContentTitle,
} from '.';

export const getAdaptedBaseCardContent = (t: TFunction, content: CardContentType) => {
  // @ts-ignore
  const { id, type, cover, name, bookmark, isOptionalContent, publicAccessConfig } = content;
  const { duration: baseDuration } = getContentDuration(t, content);
  // conversationTimeLimit is in minutes; convert to seconds for formatting
  const duration =
    content.type === ResourceTypeEnum.Roleplay && content.conversationTimeLimit != null
      ? getHumanDuration(content.conversationTimeLimit * 60)
      : baseDuration;

  let image = cover?.url;
  if (content.type === ResourceTypeEnum.KnowledgeAsset) {
    // @ts-ignore
    const image_ = getKnowledgeAssetStaticCover(content.knowledgeAssetSubType);
    if (image_) {
      image = image_;
    }
  }

  return {
    contentId: id,
    contentType: type,
    name,
    image,
    status: getContentCardStatus(t, content),
    bookmark,
    type: t(getContentTitle(content)),
    description: getContentDescription(content),
    progress: getContentCardProgress(content),
    label: getContentLabel(t, content, duration),
    duration: getContentCardDuration(t, content),
    isOptionalContent,
    microLearningSubType: content.microLearningSubType,
    publicAccessConfig,
  };
};
